import { Api } from '@coderhouse/common'
import { ICourseNew } from '../models/newSuggestedCourses'

const { VUE_APP_CH_API_BFF } = process.env

async function getMainJourney(): Promise<any> {
  const journey = await Api.get(`${VUE_APP_CH_API_BFF}/journeys/main`)
  if (!journey.tags) {
    journey.tags = []
  }
  return journey
}

async function getCoursesMainJourney(): Promise<ICourseNew> {
  const journey = await Api.get(`${VUE_APP_CH_API_BFF}/journeys/main`)
  const courses = journey.courses

  const coursesToBuy: any = []
  courses.map((item: ICourseNew) => {
    if (item.purchased == false) {
      coursesToBuy.push(item)
    }
    return coursesToBuy
  })

  const coursesToShow = coursesToBuy.slice(0, 3)
  return coursesToShow
}

export { getMainJourney }
